module.exports = __webpack_public_path__ + "static/media/cy-lab-reward.f612a997.png";